import { IconButton } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { RiDeleteBinLine, RiFileEditLine } from "react-icons/ri";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import CTable from "../../../components/Table/table";

import { openAddPaymentSubject } from "../../../modules/admin-modules/models/Actions";

const PaymentSubjectTable = ({ setAdd, setSelectedData }) => {
    const paymentSubjects = useSelector((state) => state.videos.paymentSubjects);
    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.videos.isLoading);
    const [offset, setPage] = useState(0);
    const [size, setPerPage] = useState(10);
    const [pageNumber, setPageNumber] = useState(0);
    const [selected, setSelected] = useState({
        id: "",
    });
    const viewData = (data) => {
        setSelectedData(data);
        setSelected(data);
    };
    const Data = paymentSubjects?.map((data) => {
        return {
            ...data,
            id: data?.id,
            name: data?.name,
            value: data?.value,
            edit: (
                <IconButton
                    variant="outline"
                    border="0"
                    color="gray.600"
                    aria-label="Call Sage"
                    fontSize="20px"
                    icon={<RiFileEditLine />}
                    onClick={() => {
                        console.log("edit");
                        setAdd(false);
                        dispatch(openAddPaymentSubject());
                    }}
                />
            ),
        };
    });
    const columns = [
        {
            Header: " الدفع",
            accessor: "name",
        },
        {
            Header: "القيمة",
            accessor: "value",
        },
        {
            Header: "تعديل",
            accessor: "edit",
        },
    ];

    return (
        <CTable
            selectedData={viewData}
            Columns={columns}
            Data={Data}
            path={"openModel"}
            Actions
            Title={``}
            subTitle=""
            btnTitle=""
            placeHolder=""
            noSearchBar={true}
            noFilter={true}
            footerBtnTitle
            filterList
            addButton
            addButtonTitle=""
            setPage={setPage}
            setPerPage={setPerPage}
            currentpage={pageNumber}
            setPageNumber={setPageNumber}
            noSecondSearchBar={true}
            isLoading={isLoading}
            perPage={size}
            totalPage={Math.ceil(paymentSubjects?.length / 10)}
        />
    );
};

export default PaymentSubjectTable;
